export function printSheet() {
  // if (window.localStorage.getItem("sliders")) {
  //   window.localStorage.removeItem("sliders");
  //   // alert("Turn off sliding panels to print");
  // } else {
  window.print();
  // }
}
